import classNames from "classnames/bind";
import styles from './Config.module.css';
import { useCallback, useEffect, useState } from "react";
import { Button, Loading, Toast } from "../../../../../components";
import { useContext } from "react";
import { SettingAIContext } from "../../../../../contexts";
import { getCommonObject } from "../../../../../services/api/aiConfigService";
import { ObjectLisencePlate } from "../source";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

function ConfigObject() {
    const { permissionChange, onClose, cameraCode, reGetData, setReGetData, nameService,showReload,setShowReload } = useContext(SettingAIContext);
    const [listObject, setListObject] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [seeAll, setSeeAll] = useState(false);
    const [dataMap, setDataMap] = useState([
        { CODE: 1, CODE_SYSTEM: 'person', NAME_VN: 'Người', PRIORITY: 1, STATUS: true },
        { CODE: 3, CODE_SYSTEM: 'car', NAME_VN: 'Xe hơi', PRIORITY: 1, STATUS: true },
        { CODE: 8, CODE_SYSTEM: 'truck', NAME_VN: 'Xe tải', PRIORITY: 1, STATUS: true },
    ]);
    const { t } = useTranslation()
    // 3 vật thể mặc định
    // const [reGetDataOb, setReGetData] = useState(false);
    const onChangeStatus = (code, check) => {
        setShowReload(true)
        const data = listObject.map(item => {
            if (item.CODE === code) {
                return {
                    ...item,
                    STATUS: check,
                }
            } else {
                return item
            }
        })
        setListObject(data)
        if (seeAll) {
            setDataMap(data)
        } else {
            const firstData = data.slice(0, 10);
            setDataMap(firstData)
        }
    }


    const getListCommonObject = useCallback(async () => {
        try {
            const res = getCommonObject.getList()
            return res;
        } catch (error) {
            Toast.open('Không thể lấy danh sách vật thể', 'danger')
            return null;
        }
    }, [])

    const getCameraCommonOb = useCallback(async () => {
        try {
            let param = {
                camera_code: cameraCode
            }
            if (nameService?.toLowerCase() === 'nhận dạng biển số xe') {
                const res = getCommonObject.getOfCameraAPLR(param);
                return res;
            } else {
                const res = getCommonObject.getOfCamera(param);
                return res;
            }
        } catch (error) {
            Toast.open('Không thể lấy danh sách vật thể', 'danger')
        }
    }, [cameraCode, nameService])

    const handelChangeView = () => {
        setSeeAll(!seeAll)
        setShowReload(true)
        if (seeAll) {
            let firstData = listObject.slice(0, 10);
            setDataMap(firstData);
        } else {
            setDataMap(listObject)
        }
    }

    const handleSaveConfig = async (dataCf) => {
        setIsLoading(true);
        const dataChose = dataCf?.filter(item => item?.STATUS === true);
        const listCode = dataChose?.map(item => item?.CODE);
        const jsonCode = JSON.stringify(listCode);
        try {
            if (nameService?.toLowerCase() === 'nhận dạng biển số xe') {
                let data = {
                    code_camera: cameraCode,
                    list_code_alpr_object: jsonCode,
                }
                const res = await getCommonObject.postConfigALPR(data);
                Toast.open(`Cài đặt ${nameService} thành công`, 'success')
                setIsLoading(false)
                return res;
            } else {
                let data = {
                    code_camera: cameraCode,
                    list_code_common_object: jsonCode,
                }
                const res = await getCommonObject.postConfig(data);
                Toast.open(`Cài đặt ${nameService} thành công`, 'success')
                setIsLoading(false)
                return res;
            }
        } catch (error) {
            Toast.open(`Cài đặt ${nameService} không thành công`, 'danger')
            setIsLoading(false)
        }
    }

    const objectDefaultOfService = (item) => {
        if (nameService?.toLowerCase() === 'nhận dạng biển số xe') {
            return item.CODE === 4 || item.CODE === 3 || item.CODE === 8 || item.CODE === 6;
        } else {
            return item.CODE === 1 || item.CODE === 3 || item.CODE === 8;
        }
    }

    const handleRefresh = async () => {
        setIsLoading(true)
        try {
            const listDataDefault = await getListCommonObject();
            if (listDataDefault) {
                let data = listDataDefault?.data;
                let defaultData = data?.map(item => {
                    if (objectDefaultOfService(item)) {
                        return {
                            ...item,
                            STATUS: true,
                        }
                    } else {
                        return {
                            ...item,
                            STATUS: false,
                        }
                    }
                })
                const res = await handleSaveConfig(defaultData);
                setReGetData(!reGetData)
                return res;
            }
        } catch (error) {
            Toast.open(`Cài lại mặc định ${nameService} không thành công`, 'danger');
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const getData = async () => {
            setIsLoading(true);
            let listData = [];
            if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                listData = ObjectLisencePlate;
            } else {
                listData = await getListCommonObject();
            }
            const listActive = await getCameraCommonOb();
            if (listData && listActive) {
                const dataDefault = listData?.data.map(item => {
                    let index;
                    if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                        index = listActive?.data?.findIndex(item1 => item.CODE === item1.ALPR_OBJECT_CODE);
                    } else {
                        index = listActive?.data?.findIndex(item1 => item.CODE === item1.COMMON_OBJECT_CODE);
                    }
                    if (index >= 0) {
                        return {
                            ...item,
                            STATUS: true,
                        }
                    } else {
                        if (item)
                            return {
                                ...item,
                                STATUS: false
                            }
                    }
                })
                setListObject(dataDefault)
                let firstData = dataDefault.slice(0, 9);
                setDataMap(firstData)
            }
            setIsLoading(false);
        }
        getData()
    }, [getListCommonObject, getCameraCommonOb, reGetData, nameService])
    const handleCancel = () => {
        // onClose();
        setReGetData(!reGetData);
    }
    return (
        <div className={cx('wrapper')}>
            <div id="__notification"></div>
            {isLoading ? (
                <div><Loading /></div>
            ) : (
                <>
                    <div className={cx('list-item')}>
                        {dataMap.length > 0 && dataMap?.map((item) => {
                            return (
                                <div className={cx('item')} key={item.CODE}>
                                    <input
                                        className={cx('input-name')}
                                        name={'check-common'}
                                        checked={item.STATUS}
                                        type="checkbox"
                                        onChange={(e) => onChangeStatus(item.CODE, e.target.checked)}
                                    />
                                    <label
                                        className={cx('label')}
                                        htmlFor={'check-common'}
                                        onClick={() => onChangeStatus(item.CODE, item.STATUS)}
                                    >
                                        {localStorage?.getItem('laguage') === "en" ? item?.CODE_SYSTEM : item.NAME_VN}
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                    <div className={cx('show-more-btn')}
                        onClick={handelChangeView}
                    >{dataMap.length >= 9 ? (seeAll ? t("setting.View_Partial") : t("setting.View_all")) : ''}</div>
                    {permissionChange && (
                        <div className={cx("actions-setting")}>
                            <Button
                                onClick={handleRefresh}
                                className={cx("btn-save")}
                                title={t('setting.Reset_to_default')}
                            />
                            {showReload &&   <Button className={cx("btn-cancle")} title={t('cameraControl.Cancel')} onClick={handleCancel} />}
                            <Button
                                onClick={() => handleSaveConfig(listObject)}
                                className={cx("btn-save")}
                                title={t('settingCam.Save_settings')}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default ConfigObject;